module.exports = __webpack_public_path__ + "static/media/ITCAvantGardeStd-Bk.819bd66b.svg";